module.exports = __webpack_public_path__ + "img/news-4.9dc54e43.png";